import { z } from 'zod';
import {
  ENUM_STATUS_SERVICE,
  ENUM_METHOD_SERVICE,
  ARRAY_PROTOCOL_TYPE_SERVICE,
  ARRAY_STATUS_SERVICE,ARRAY_METHOD_SERVICE,ARRAY_AUTH_TYPE
} from '../interfaces/services.interface';
export const conectorInteroperabilitySchema = z
  .object({
    code: z
      .string()
      .max(100, 'El código no puede superar los 100 caracteres')
      .optional()
      .or(z.literal('')),

    name: z
      .string()
      .trim()
      .min(1, 'El nombre del conector es obligatorio')
      .max(150, 'El nombre no puede superar los 150 caracteres'),

    institution: z
      .string()
      .trim()
      .min(1, 'La institución es obligatoria')
      .max(200, 'La institución no puede superar los 200 caracteres'),

    version: z
      .string()
      .trim()
      .min(1, 'La versión es obligatoria')
      .max(30, 'La versión no puede superar los 30 caracteres'),

    status: z
      .enum(ARRAY_STATUS_SERVICE)
      .default(ENUM_STATUS_SERVICE.CONNECTED),

    method: z.enum(ARRAY_METHOD_SERVICE),

    protocolType: z.enum(ARRAY_PROTOCOL_TYPE_SERVICE),

    authType: z.enum(ARRAY_AUTH_TYPE),

    authToken: z.string().optional().or(z.literal('')),

    authUser: z.string().optional().or(z.literal('')),

    authPasswordRaw: z.string().optional().or(z.literal('')),

    endpointUrl: z
      .string()
      .trim()
      .url('La URL del servicio no es válida')
      .optional()
      .or(z.literal('')),

    soapAction: z.string().trim().optional().or(z.literal('')),

    timeoutMs: z.coerce
      .number()
      .min(1000, 'El timeout mínimo es de 1000 ms')
      .max(120000, 'El timeout máximo es de 120000 ms'),

    headersStr: z
      .string()
      .min(1, 'Los encabezados no pueden estar vacíos')
      .refine((value) => {
        try {
          const parsed = JSON.parse(value);
          return parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed);
        } catch {
          return false;
        }
      }, 'Los encabezados deben contener un JSON válido'),

    queryParamsStr: z
      .string()
      .min(1, 'Los parámetros Query no pueden estar vacíos')
      .refine((value) => {
        try {
          const parsed = JSON.parse(value);
          return parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed);
        } catch {
          return false;
        }
      }, 'Los parámetros Query deben contener un JSON válido'),

    requestStr: z
      .string()
      .min(1, 'El esquema de petición no puede estar vacío')
      .refine((value) => {
        try {
          JSON.parse(value);
          return true;
        } catch {
          return false;
        }
      }, 'El esquema de petición debe contener un JSON válido'),

    responseStr: z
      .string()
      .min(1, 'El esquema de respuesta no puede estar vacío')
      .refine((value) => {
        try {
          JSON.parse(value);
          return true;
        } catch {
          return false;
        }
      }, 'El esquema de respuesta debe contener un JSON válido'),
  })
  .superRefine((data, ctx) => {
    // Endpoint obligatorio cuando no es MOCK
    if (data.protocolType !== 'MOCK' && !data.endpointUrl.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['endpointUrl'],
        message: 'La URL del servicio es obligatoria',
      });
    }

    // SOAP Action obligatorio para SOAP
    if (data.protocolType === 'SOAP' && !data.soapAction.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['soapAction'],
        message: 'El SOAP Action es obligatorio para servicios SOAP',
      });
    }

    // Bearer requiere token
    if (data.authType === 'BEARER' && !data.authToken?.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['authToken'],
        message: 'El token Bearer es obligatorio',
      });
    }

    // API Key requiere token
    if (
      (data.authType === 'API_KEY_HEADER' || data.authType === 'API_KEY_QUERY') &&
      !data.authToken?.trim()
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['authToken'],
        message: 'La API Key es obligatoria',
      });
    }

    // Basic Auth requiere usuario
    if (data.authType === 'BASIC' && !data.authUser?.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['authUser'],
        message: 'El usuario es obligatorio para Basic Auth',
      });
    }

    // Basic Auth requiere contraseña en creación
    if (data.authType === 'BASIC' && !data.authPasswordRaw?.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['authPasswordRaw'],
        message: 'La contraseña es obligatoria para Basic Auth',
      });
    }
  });
